import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import AuthGuard from './../components/common/AuthGuard';
// import ForgotPasswordPage from './../pages/ForgotPasswordPage';
import HomePage from './../pages/HomePage';
import Login from './../pages/Login';
import PrivacyPolicy from './../pages/PrivacyPolicy';
import TermsOfService from './../pages/TermsOfService';
import CoursePage from "../pages/CoursePage";
import PricingPage from "../pages/PricingPage";
import LessionPage from "../pages/LessionPage";
import MyCoursePage from "../pages/MyCoursePage";
import MyOrderPage from "../pages/MyOrderPage";
import MySettingPage from "../pages/MySettingPage";
import FAQPage from "../pages/FAQPage";
import WalletPage from "../pages/WalletPage";
import PayosCancel from "../pages/PayosCancel";
import ExchangePage from "../pages/ExchangePage";

const AppRoutes = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" exact element={<HomePage />} />
                <Route path="/course/:courseId" exact element={<CoursePage />} />
                <Route path="/course/:courseId/lessons/:lessonId" exact element={<LessionPage />} />
                <Route path="/faq" exact element={<FAQPage />} />
                <Route path="/account/mywallet" exact element={<AuthGuard><WalletPage /></AuthGuard>} />
                <Route path="/account/courses" exact element={<AuthGuard><MyCoursePage /></AuthGuard>} />
                <Route path="/account/orders" exact element={<AuthGuard><MyOrderPage /></AuthGuard>} />
                <Route path="/account/settings" exact element={<AuthGuard><MySettingPage /></AuthGuard>} />
                <Route path="/pricing" exact element={<PricingPage />} />
                <Route path="/exchange" exact element={<ExchangePage />} />
                <Route path="/login" exact element={<Login />} />
                {/* <Route path="/forgot-password" exact element={<ForgotPasswordPage />} /> */}
                <Route path="/privacy-policy" exact element={<PrivacyPolicy />} />
                <Route path="/terms-of-service" exact element={<TermsOfService />} />
                {/* <Route path="/payos-success" exact element={<PayosSuccess />} /> */}
                <Route path="/payos-cancel" exact element={<PayosCancel />} />
            </Routes>
        </Router>
    );
};

export default AppRoutes;
